module.exports = __webpack_public_path__ + "img/fractions.799da6e4.svg";